import React from 'react';
import { Line } from 'rc-progress';
import { Ball } from './';

class InputDocumentFile extends React.Component {
  state = {
    percent: 0,
    displayProgress: true,
  }

  componentDidMount() {
    const { name } = this.props;
    if (name) {
      this.progressBar()
    }
  }

  progressBar() {
    setTimeout(() => {
      this.setState({
        percent: 50,
      })
    }, 500);
    setTimeout(() => {
      this.setState({
        percent: 100,
      })
    }, 1500);
    setTimeout(() => {
      this.setState({
        displayProgress: false,
      })
    }, 2000)
  }

  render() {
    const { name, removeFile, showModal, progress, approved, comment } = this.props;

    return (
      <div className="documents-uploaded">
        {progress > 0 && <Line percent={progress} strokeWidth="1" strokeColor="#00ae97" className={this.state.displayProgress === false ? 'd-none' : null} />}
        <div className="d-flex align-items-center">
          <div className="documents-length-0">
            {name}
            {comment && (<small className="d-block danger"><b>Documento reprovado:</b> {comment}</small>)}
            {approved && (<small className="d-block success">Documento aprovado.</small>)}
          </div>

          <button className="btn-none" type="button" onClick={showModal}>
            <Ball
              icon="view"
              extraSmall
              bgColor="white"
              iconWidth="16"
            />
          </button>
          {/* Documentos aprovados não podem ser removidos */}
          {[null, false].includes(approved) && (
            <button className="btn-none" type="button" onClick={removeFile}>
              <Ball
                icon="trash"
                bgColor="white"
                iconWidth="16"
                extraSmall
              />
            </button>
          )}
        </div>
      </div>
    );
  }
}

InputDocumentFile.defaultProps = {
  progress: 0,
  approved: null,  // Simula um documento não revisado.
};

export default InputDocumentFile;
